export default __webpack_public_path__ + "static/media/workingblue.b38aa90c.jpg";